<script lang="ts">
    
    import type { PictureDto } from "../../global";
    import { formatDate } from "../../Services/date";

    export let picture: PictureDto;

    $: hasUploaderInfo = 'user_name' in picture.meta;

</script>

<div class="picture-meta">
    {#if hasUploaderInfo}
        <div class="uploader">
            Subida por <span class="user-name">{picture.meta.user_name}</span>
        </div>
    {/if}
    <div class="picture-date">
        {formatDate(picture.createdDate)}
    </div>
</div>

<style lang="scss">

    .picture-meta {
        text-align: center;
    }

    .user-name {
        font-style: italic;
    }

</style>
